import * as React from "react";
import Dialog from "@mui/material/Dialog";
import Button from "../Button";
import i18next from "i18next";
import Label from "../Label";

export interface SimpleDialogProps {
	open: boolean;
	title: string;
	subtitle?: string;
	handleConfirm: () => void;
	handleCancel: () => void;
}

export default function ConfirmDialog({ handleCancel, handleConfirm, open, title, subtitle }: SimpleDialogProps) {
	return (
		<Dialog onClose={handleCancel} open={open} maxWidth="md">
			<div className="p-4">
				<Label subtitleClassName={""} text={title}></Label>
				{subtitle && <div className="pt-1">{subtitle}</div>}

				<div className="d-flex mt-4 justify-content-end">
					<Button
						label={i18next.t("cancel")}
						onClick={handleCancel}
						secondary
						datatestid={"cancel-dialog-button"}
					/>
					<Button
						label={i18next.t("accept")}
						onClick={handleConfirm}
						className="ms-4"
						datatestid={"accept-dialog-button"}
					/>
				</div>
			</div>
		</Dialog>
	);
}
